import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transformer-monitoring',
  templateUrl: './transformer-monitoring.component.html',
  styleUrls: ['./transformer-monitoring.component.scss']
})
export class TransformerMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
